import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { CategoriesComponent } from './categories/categories.component';
import { CategoriesService } from './categories/categories.service';
import { AuthGuard } from '../../../core/services/auth-guard.service';
import { CategoryComponent } from './category/category.component';
import { CategoryService } from './category/category.service';
import { ProductsComponent } from './products/products.component';
import { ProductsService } from './products/products.service';
import { ProductComponent } from './product/product.component';
import { ProductService } from './product/product.service';
import { TicketFormDialogComponent } from './product/ticket-form/ticket-form.component';
import { OrdersComponent } from './orders/orders.component';
import { DashboardOrdersService } from './orders/orders.service';
import { OrderComponent } from './order/order.component';
import { DashboardOrderService } from './order/order.service';
import { InvoiceComponent } from './invoice/invoice.component';
import { PreordersComponent } from './preorders/preorders.component';
import { DashboardPreordersService } from './preorders/preorders.service';
import { SubcategoriesComponent } from './subcategories/subcategories.component';
import { SubcategoriesService } from './subcategories/subcategories.service';
import { UsersComponent } from './users/users.component';
import { UserComponent } from './user/user.component';
import { UsersService } from '../../../core/services/users/users.service';
import { TransactionsService } from '../../../core/services/transactions/transactions.service';
import { TransacFormDialogComponent } from './order/transac-form/transac-form.component';
import { InvoicepageComponent } from './invoicepage/invoicepage.component';
import { InvoicepageService } from './invoicepage/invoicepage.service';
import { TransactionsComponent } from './transactions/transactions.component';
import { TransacsService } from './transactions/transacs.service';
import { TransactionsExportFormDialogComponent } from './transactions/event-form/event-form.component';
import { TicketComponent } from './ticket/ticket.component';
import { OrderItemComponent } from './order/order-item/order-item.component';
import { TicketAddFormDialogComponent } from './order/ticket-add-form/ticket-add-form.component';
import { VouchersComponent } from './vouchers/vouchers.component';
import { VouchersComponentService } from './vouchers/vouchers.component.service';
import { VoucherFormDialogComponent } from './vouchers/voucher-form/voucher-form.component';
import { ClosedDatesFormDialogComponent } from './product/closed-dates/closed-dates-form.component';
import { BonResaPageComponent } from './bonresapage/bonresapage.component';
import { BonResaComponent } from './bonresa/bonresa.component';
import { BRComponent } from './br/br.component';
import { FactureComponent } from './facture/facture.component';

const routes = [
    /* {
        path        : 'dashboards/project',
        loadChildren: './dashboards/project/project.module#FuseProjectDashboardModule'
    }, */
    {
        path        : 'calendar',
        loadChildren: './calendar/calendar.module#FuseCalendarModule',
        canActivate: [AuthGuard]
    },
    {
        path        : 'schedules',
        loadChildren: './schedules/schedules.module#FuseSchedulesModule',
        canActivate: [AuthGuard]
    },
    {
        path     : 'categories',
        component: CategoriesComponent,
        resolve  : {
            data: CategoriesService
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'categories/:id',
        component: SubcategoriesComponent,
        resolve  : {
            data: SubcategoriesService
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'category/:id',
        component: CategoryComponent,
        resolve  : {
            data: CategoryService
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'products',
        component: ProductsComponent,
        resolve  : {
            data: ProductsService
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'products/:id',
        component: ProductComponent,
        resolve  : {
            data: ProductService
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'orders',
        component: OrdersComponent,
        resolve  : {
            data: DashboardOrdersService
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'preorders',
        component: PreordersComponent,
        resolve  : {
            data: DashboardPreordersService,
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'order/:id',
        component: OrderComponent,
        resolve  : {
            data: DashboardOrderService,
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'users',
        component: UsersComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'user/:id',
        component: UserComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'invoice/:id',
        component: InvoicepageComponent,
        resolve  : {
            data: InvoicepageService,
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'facture/:id',
        component: FactureComponent,
        resolve  : {
            data: InvoicepageService,
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'br/:id',
        component: BonResaPageComponent,
        resolve  : {
            data: InvoicepageService,
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'transactions',
        component: TransactionsComponent,
        resolve  : {
            data: TransacsService,
        },
        canActivate: [AuthGuard]
    },
    {
        path     : 'vouchers',
        component: VouchersComponent,
        resolve  : {
            data: VouchersComponentService
        },
        canActivate: [AuthGuard]
    },
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
    ],
    declarations: [
        TicketFormDialogComponent,
        TicketAddFormDialogComponent,
        TransacFormDialogComponent,
        CategoriesComponent,
        CategoryComponent,
        ProductsComponent,
        ProductComponent,
        OrdersComponent,
        OrderComponent,
        OrderItemComponent,
        InvoiceComponent,
        InvoicepageComponent,
        BonResaComponent,
        BonResaPageComponent,
        TicketComponent,
        BRComponent,
        PreordersComponent,
        SubcategoriesComponent,
        UserComponent,
        UsersComponent,
        TransactionsComponent,
        TransactionsExportFormDialogComponent,
        VouchersComponent,
        VoucherFormDialogComponent,
        ClosedDatesFormDialogComponent,
        FactureComponent,
    ],
    providers: [
        CategoriesService,
        SubcategoriesService,
        CategoryService,
        ProductsService,
        ProductService,
        TransactionsService,
        DashboardOrdersService,
        DashboardOrderService,
        DashboardPreordersService,
        UsersService,
        InvoicepageService,
        TransacsService,
        VouchersComponentService,
    ],
    entryComponents: [
        TicketFormDialogComponent,
        TicketAddFormDialogComponent,
        TransacFormDialogComponent,
        TransactionsExportFormDialogComponent,
        VoucherFormDialogComponent,
        ClosedDatesFormDialogComponent,
    ]
})
export class AppsModule {}




// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/apps.module.ts